/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddPatchRicaricaDTO } from '../model/addPatchRicaricaDTO';
import { AddPatchSaldiInizialiDTO } from '../model/addPatchSaldiInizialiDTO';
import { AddPatchSaldoInizialeDTO } from '../model/addPatchSaldoInizialeDTO';
import { AnagraficaView } from '../model/anagraficaView';
import { DifformitaPastiDTO } from '../model/difformitaPastiDTO';
import { EventoCalendarioDTO } from '../model/eventoCalendarioDTO';
import { EventoCalendarioStudenteForm } from '../model/eventoCalendarioStudenteForm';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GeneraDovutoDTO } from '../model/generaDovutoDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { GetRendicontazioneView } from '../model/getRendicontazioneView';
import { GetRicaricaView } from '../model/getRicaricaView';
import { GetRicaricheResponseDTO } from '../model/getRicaricheResponseDTO';
import { GetStudenteDTO } from '../model/getStudenteDTO';
import { GetStudenteDetailView } from '../model/getStudenteDetailView';
import { GetStudenteView } from '../model/getStudenteView';
import { IdentificativoMenuExtraForm } from '../model/identificativoMenuExtraForm';
import { MultiricaricaDTO } from '../model/multiricaricaDTO';
import { PageGetStudenteDTO } from '../model/pageGetStudenteDTO';
import { PageGetStudenteRicaricheView } from '../model/pageGetStudenteRicaricheView';
import { PatchEsenzioneDTO } from '../model/patchEsenzioneDTO';
import { PatchSospensioneStudenteDTO } from '../model/patchSospensioneStudenteDTO';
import { Rendicontazione } from '../model/rendicontazione';
import { Ricarica } from '../model/ricarica';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class StudentiService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Permette di aggiungere/modificare il saldo iniziale di una lista di studenti.
     * Imposta o aggiorna in blocco il saldo iniziale del portafoglio per una lista di studenti.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addEditSaldiIniziali(body: Array<AddPatchSaldiInizialiDTO>, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public addEditSaldiIniziali(body: Array<AddPatchSaldiInizialiDTO>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public addEditSaldiIniziali(body: Array<AddPatchSaldiInizialiDTO>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public addEditSaldiIniziali(body: Array<AddPatchSaldiInizialiDTO>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addEditSaldiIniziali.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/studente/saldi-iniziali`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiungere/modificare il saldo iniziale di uno studente.
     * Imposta o aggiorna il saldo iniziale del portafoglio di uno studente per l&#x27;anno di riferimento.
     * @param body 
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addEditSaldoIniziale(body: AddPatchSaldoInizialeDTO, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public addEditSaldoIniziale(body: AddPatchSaldoInizialeDTO, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public addEditSaldoIniziale(body: AddPatchSaldoInizialeDTO, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public addEditSaldoIniziale(body: AddPatchSaldoInizialeDTO, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addEditSaldoIniziale.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling addEditSaldoIniziale.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetStudenteView>('put',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/saldo-iniziale`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un GENITORE di aggiungere un evento calendario ad uno studente.
     * Aggiunge un evento al calendario dello studente (es. dieta speciale, assenza). Accessibile al genitore dello studente.
     * @param body Attributi del&#x27;evento calendario&#x27;.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addEventoCalendario(body: EventoCalendarioStudenteForm, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<Array<EventoCalendarioDTO>>;
    public addEventoCalendario(body: EventoCalendarioStudenteForm, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EventoCalendarioDTO>>>;
    public addEventoCalendario(body: EventoCalendarioStudenteForm, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EventoCalendarioDTO>>>;
    public addEventoCalendario(body: EventoCalendarioStudenteForm, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addEventoCalendario.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling addEventoCalendario.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<EventoCalendarioDTO>>('post',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/evento-calendario`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiungere una o più ricariche agli studenti.
     * Registra in blocco più pagamenti (multiricarica) per uno o più studenti in un&#x27;unica operazione.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addMultiricariche(body: MultiricaricaDTO, observe?: 'body', reportProgress?: boolean): Observable<Array<GetStudenteView>>;
    public addMultiricariche(body: MultiricaricaDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetStudenteView>>>;
    public addMultiricariche(body: MultiricaricaDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetStudenteView>>>;
    public addMultiricariche(body: MultiricaricaDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addMultiricariche.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<GetStudenteView>>('post',`${this.basePath}/api/v1/studente/ricariche`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiungere una ricarica ad uno studente.
     * Registra un nuovo pagamento (ricarica) per lo studente specificato e aggiorna il saldo del portafoglio.
     * @param body 
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addRicarica(body: AddPatchRicaricaDTO, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public addRicarica(body: AddPatchRicaricaDTO, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public addRicarica(body: AddPatchRicaricaDTO, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public addRicarica(body: AddPatchRicaricaDTO, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addRicarica.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling addRicarica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetStudenteView>('post',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricarica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di avviare il flusso di pagamento per un avviso.
     * Avvia il processo di pagamento PagoPA per la ricarica specificata, restituendo l&#x27;URL di redirect verso il portale di pagamento.
     * @param id_studente 
     * @param id_ricarica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public avviaPagamento(id_studente: string, id_ricarica: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public avviaPagamento(id_studente: string, id_ricarica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public avviaPagamento(id_studente: string, id_ricarica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public avviaPagamento(id_studente: string, id_ricarica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling avviaPagamento.');
        }

        if (id_ricarica === null || id_ricarica === undefined) {
            throw new Error('Required parameter id_ricarica was null or undefined when calling avviaPagamento.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_ricarica !== undefined && id_ricarica !== null) {
            queryParameters = queryParameters.set('id_ricarica', <any>id_ricarica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/avvia-pagamento`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di cancellare un pagamento.
     * Annulla il dovuto PagoPA associato alla ricarica specificata e aggiorna lo stato della ricarica a CANCELLATA.
     * @param id_studente 
     * @param id_ricarica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancellaPagamento(id_studente: string, id_ricarica: string, observe?: 'body', reportProgress?: boolean): Observable<Ricarica>;
    public cancellaPagamento(id_studente: string, id_ricarica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Ricarica>>;
    public cancellaPagamento(id_studente: string, id_ricarica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Ricarica>>;
    public cancellaPagamento(id_studente: string, id_ricarica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling cancellaPagamento.');
        }

        if (id_ricarica === null || id_ricarica === undefined) {
            throw new Error('Required parameter id_ricarica was null or undefined when calling cancellaPagamento.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_ricarica !== undefined && id_ricarica !== null) {
            queryParameters = queryParameters.set('id_ricarica', <any>id_ricarica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Ricarica>('delete',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/cancella-pagamento`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di informare del pagamento di una ricarica.
     * Verifica e aggiorna lo stato di una ricarica a seguito del completamento del pagamento PagoPA, identificata tramite IUV.
     * @param id_studente 
     * @param iuv 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkRicaricaEseguita(id_studente: string, iuv: string, observe?: 'body', reportProgress?: boolean): Observable<Ricarica>;
    public checkRicaricaEseguita(id_studente: string, iuv: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Ricarica>>;
    public checkRicaricaEseguita(id_studente: string, iuv: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Ricarica>>;
    public checkRicaricaEseguita(id_studente: string, iuv: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling checkRicaricaEseguita.');
        }

        if (iuv === null || iuv === undefined) {
            throw new Error('Required parameter iuv was null or undefined when calling checkRicaricaEseguita.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (iuv !== undefined && iuv !== null) {
            queryParameters = queryParameters.set('iuv', <any>iuv);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Ricarica>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricarica-eseguita`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di generare il dovuto per una rendicontazione relativa ad uno studente.
     * Crea una posizione debitoria PagoPA per la rendicontazione mensile dello studente specificato.
     * @param body 
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generaDovuto(body: GeneraDovutoDTO, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<Ricarica>;
    public generaDovuto(body: GeneraDovutoDTO, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Ricarica>>;
    public generaDovuto(body: GeneraDovutoDTO, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Ricarica>>;
    public generaDovuto(body: GeneraDovutoDTO, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling generaDovuto.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling generaDovuto.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Ricarica>('post',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/genera-dovuto`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di scaricare l&#x27;avviso per una ricarica di uno studente.
     * Scarica il file PDF dell&#x27;avviso di pagamento PagoPA associato a una ricarica dello studente.
     * @param id_studente 
     * @param id_ricarica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAvviso(id_studente: string, id_ricarica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getAvviso(id_studente: string, id_ricarica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getAvviso(id_studente: string, id_ricarica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getAvviso(id_studente: string, id_ricarica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getAvviso.');
        }

        if (id_ricarica === null || id_ricarica === undefined) {
            throw new Error('Required parameter id_ricarica was null or undefined when calling getAvviso.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_ricarica !== undefined && id_ricarica !== null) {
            queryParameters = queryParameters.set('id_ricarica', <any>id_ricarica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/download-avviso-pagamento`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere gli eventi calendario di uno studente.
     * Restituisce la lista di tutti gli eventi calendario attivi associati allo studente.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEventiCalendario(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<Array<EventoCalendarioDTO>>;
    public getEventiCalendario(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EventoCalendarioDTO>>>;
    public getEventiCalendario(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EventoCalendarioDTO>>>;
    public getEventiCalendario(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getEventiCalendario.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<EventoCalendarioDTO>>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/evento-calendario`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere la lista dei fratelli per uno studente.
     * Restituisce la lista degli altri studenti iscritti alla mensa che condividono lo stesso genitore.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFratelliStudente(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GetStudenteDTO>>;
    public getFratelliStudente(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetStudenteDTO>>>;
    public getFratelliStudente(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetStudenteDTO>>>;
    public getFratelliStudente(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getFratelliStudente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<GetStudenteDTO>>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/fratelli`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere l&#x27;anagrafica genitore di uno studente.
     * Restituisce i dati anagrafici del genitore associato allo studente specificato.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGenitoreStudente(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<AnagraficaView>;
    public getGenitoreStudente(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AnagraficaView>>;
    public getGenitoreStudente(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AnagraficaView>>;
    public getGenitoreStudente(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getGenitoreStudente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AnagraficaView>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/genitore`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere la lista delle rendicontazioni per uno studente.
     * Restituisce l&#x27;elenco delle rendicontazioni mensili del servizio mensa per lo studente specificato.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRendicontazioni(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GetRendicontazioneView>>;
    public getRendicontazioni(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetRendicontazioneView>>>;
    public getRendicontazioni(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetRendicontazioneView>>>;
    public getRendicontazioni(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getRendicontazioni.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<GetRendicontazioneView>>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/rendicontazioni`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere una singola ricarica per ID per uno studente.
     * Restituisce il dettaglio di una singola ricarica identificata dal suo ID per lo studente specificato.
     * @param id_studente 
     * @param id_ricarica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRicarica(id_studente: string, id_ricarica: string, observe?: 'body', reportProgress?: boolean): Observable<GetRicaricaView>;
    public getRicarica(id_studente: string, id_ricarica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetRicaricaView>>;
    public getRicarica(id_studente: string, id_ricarica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetRicaricaView>>;
    public getRicarica(id_studente: string, id_ricarica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getRicarica.');
        }

        if (id_ricarica === null || id_ricarica === undefined) {
            throw new Error('Required parameter id_ricarica was null or undefined when calling getRicarica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetRicaricaView>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricariche/${encodeURIComponent(String(id_ricarica))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere la lista delle ricariche eseguite per uno studente.
     * Restituisce l&#x27;elenco completo delle ricariche (pagamenti) effettuate per lo studente, incluse quelle in attesa e annullate.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRicariche(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetRicaricheResponseDTO>;
    public getRicariche(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetRicaricheResponseDTO>>;
    public getRicariche(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetRicaricheResponseDTO>>;
    public getRicariche(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getRicariche.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetRicaricheResponseDTO>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricariche`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di scaricare la ricevuta per una ricarica di uno studente.
     * Scarica il file PDF della ricevuta di pagamento associata a una ricarica completata dello studente.
     * @param id_studente 
     * @param id_ricarica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRicevuta(id_studente: string, id_ricarica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getRicevuta(id_studente: string, id_ricarica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getRicevuta(id_studente: string, id_ricarica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getRicevuta(id_studente: string, id_ricarica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getRicevuta.');
        }

        if (id_ricarica === null || id_ricarica === undefined) {
            throw new Error('Required parameter id_ricarica was null or undefined when calling getRicevuta.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_ricarica !== undefined && id_ricarica !== null) {
            queryParameters = queryParameters.set('id_ricarica', <any>id_ricarica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/download-ricevuta-pagamento`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere i dettagli completi di uno studente con aggiornamenti (solo ADMIN).
     * Restituisce il dettaglio completo di uno studente comprensivo di portafogli, ricariche e aggiornamenti. Accessibile solo agli utenti ADMIN.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStudenteDetail(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteDetailView>;
    public getStudenteDetail(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteDetailView>>;
    public getStudenteDetail(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteDetailView>>;
    public getStudenteDetail(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling getStudenteDetail.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetStudenteDetailView>('get',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/dettagli`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere la lista degli studenti.
     * Restituisce la lista paginata degli studenti di un comune, con possibilità di filtro e ordinamento.
     * @param slugComune 
     * @param nominativo 
     * @param codicePratica 
     * @param nomeScuola 
     * @param plessoScuola 
     * @param sezione 
     * @param classe 
     * @param pastiResiduiMaggioriDi 
     * @param pastiResiduiMinoriDi 
     * @param dietaAlternativa 
     * @param isEsente 
     * @param isSospeso 
     * @param page Pagina di risultati da estrarre [0..N]
     * @param size Numero di elementi per pagina
     * @param sort Criteri di ordinamento nel formato: {property,(asc|desc)}. L&#x27;ordinamento predefinito è crescente per ordering, sono supportati più criteri di ordinamento.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStudentiForm(slugComune: string, nominativo?: string, codicePratica?: string, nomeScuola?: string, plessoScuola?: string, sezione?: string, classe?: string, pastiResiduiMaggioriDi?: number, pastiResiduiMinoriDi?: number, dietaAlternativa?: string, isEsente?: boolean, isSospeso?: boolean, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean): Observable<PageGetStudenteDTO>;
    public getStudentiForm(slugComune: string, nominativo?: string, codicePratica?: string, nomeScuola?: string, plessoScuola?: string, sezione?: string, classe?: string, pastiResiduiMaggioriDi?: number, pastiResiduiMinoriDi?: number, dietaAlternativa?: string, isEsente?: boolean, isSospeso?: boolean, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageGetStudenteDTO>>;
    public getStudentiForm(slugComune: string, nominativo?: string, codicePratica?: string, nomeScuola?: string, plessoScuola?: string, sezione?: string, classe?: string, pastiResiduiMaggioriDi?: number, pastiResiduiMinoriDi?: number, dietaAlternativa?: string, isEsente?: boolean, isSospeso?: boolean, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageGetStudenteDTO>>;
    public getStudentiForm(slugComune: string, nominativo?: string, codicePratica?: string, nomeScuola?: string, plessoScuola?: string, sezione?: string, classe?: string, pastiResiduiMaggioriDi?: number, pastiResiduiMinoriDi?: number, dietaAlternativa?: string, isEsente?: boolean, isSospeso?: boolean, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getStudenti.');
        }















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (nominativo !== undefined) {
            formParams = formParams.append('nominativo', <any>nominativo) as any || formParams;
        }
        if (codicePratica !== undefined) {
            formParams = formParams.append('codicePratica', <any>codicePratica) as any || formParams;
        }
        if (nomeScuola !== undefined) {
            formParams = formParams.append('nomeScuola', <any>nomeScuola) as any || formParams;
        }
        if (plessoScuola !== undefined) {
            formParams = formParams.append('plessoScuola', <any>plessoScuola) as any || formParams;
        }
        if (sezione !== undefined) {
            formParams = formParams.append('sezione', <any>sezione) as any || formParams;
        }
        if (classe !== undefined) {
            formParams = formParams.append('classe', <any>classe) as any || formParams;
        }
        if (pastiResiduiMaggioriDi !== undefined) {
            formParams = formParams.append('pastiResiduiMaggioriDi', <any>pastiResiduiMaggioriDi) as any || formParams;
        }
        if (pastiResiduiMinoriDi !== undefined) {
            formParams = formParams.append('pastiResiduiMinoriDi', <any>pastiResiduiMinoriDi) as any || formParams;
        }
        if (dietaAlternativa !== undefined) {
            formParams = formParams.append('dietaAlternativa', <any>dietaAlternativa) as any || formParams;
        }
        if (isEsente !== undefined) {
            formParams = formParams.append('isEsente', <any>isEsente) as any || formParams;
        }
        if (isSospeso !== undefined) {
            formParams = formParams.append('isSospeso', <any>isSospeso) as any || formParams;
        }

        return this.httpClient.request<PageGetStudenteDTO>('post',`${this.basePath}/api/v1/studente`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere la lista degli studenti per eseguire il report.
     * Restituisce la lista paginata degli studenti con le relative ricariche, da utilizzare per la generazione di report.
     * @param slugComune 
     * @param page Pagina di risultati da estrarre [0..N]
     * @param size Numero di elementi per pagina
     * @param sort Criteri di ordinamento nel formato: {property,(asc|desc)}. L&#x27;ordinamento predefinito è crescente per ordering, sono supportati più criteri di ordinamento.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStudentiForReport(slugComune: string, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean): Observable<PageGetStudenteRicaricheView>;
    public getStudentiForReport(slugComune: string, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageGetStudenteRicaricheView>>;
    public getStudentiForReport(slugComune: string, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageGetStudenteRicaricheView>>;
    public getStudentiForReport(slugComune: string, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getStudentiForReport.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageGetStudenteRicaricheView>('get',`${this.basePath}/api/v1/studente/report`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiornare lo stato di esenzione di uno studente.
     * Abilita o disabilita l&#x27;esenzione dal pagamento del servizio mensa per uno studente.
     * @param body 
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchEsenzioneStudente(body: PatchEsenzioneDTO, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public patchEsenzioneStudente(body: PatchEsenzioneDTO, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public patchEsenzioneStudente(body: PatchEsenzioneDTO, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public patchEsenzioneStudente(body: PatchEsenzioneDTO, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchEsenzioneStudente.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling patchEsenzioneStudente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetStudenteView>('patch',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/esenzione`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiornare una ricarica ad uno studente.
     * Aggiorna parzialmente i dati di una ricarica esistente per lo studente specificato.
     * @param body 
     * @param id_studente 
     * @param id_ricarica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchRicarica(body: AddPatchRicaricaDTO, id_studente: string, id_ricarica: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public patchRicarica(body: AddPatchRicaricaDTO, id_studente: string, id_ricarica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public patchRicarica(body: AddPatchRicaricaDTO, id_studente: string, id_ricarica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public patchRicarica(body: AddPatchRicaricaDTO, id_studente: string, id_ricarica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchRicarica.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling patchRicarica.');
        }

        if (id_ricarica === null || id_ricarica === undefined) {
            throw new Error('Required parameter id_ricarica was null or undefined when calling patchRicarica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetStudenteView>('patch',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricarica/${encodeURIComponent(String(id_ricarica))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiornare lo stato di sospensione di uno studente.
     * Abilita o disabilita la sospensione del servizio mensa per uno studente.
     * @param body 
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchSospensioneStudente(body: PatchSospensioneStudenteDTO, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public patchSospensioneStudente(body: PatchSospensioneStudenteDTO, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public patchSospensioneStudente(body: PatchSospensioneStudenteDTO, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public patchSospensioneStudente(body: PatchSospensioneStudenteDTO, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchSospensioneStudente.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling patchSospensioneStudente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetStudenteView>('patch',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/sospensione`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un GENITORE di rimuovere (cancellazione logica) un evento calendario ad uno studente.
     * Esegue una cancellazione logica di un evento calendario dello studente. Accessibile al genitore dello studente.
     * @param id_studente 
     * @param id_evento 
     * @param forzaEvento 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeEventoCalendario(id_studente: string, id_evento: string, forzaEvento?: boolean, observe?: 'body', reportProgress?: boolean): Observable<EventoCalendarioDTO>;
    public removeEventoCalendario(id_studente: string, id_evento: string, forzaEvento?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventoCalendarioDTO>>;
    public removeEventoCalendario(id_studente: string, id_evento: string, forzaEvento?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventoCalendarioDTO>>;
    public removeEventoCalendario(id_studente: string, id_evento: string, forzaEvento?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling removeEventoCalendario.');
        }

        if (id_evento === null || id_evento === undefined) {
            throw new Error('Required parameter id_evento was null or undefined when calling removeEventoCalendario.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (forzaEvento !== undefined && forzaEvento !== null) {
            queryParameters = queryParameters.set('forzaEvento', <any>forzaEvento);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EventoCalendarioDTO>('delete',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/evento-calendario/${encodeURIComponent(String(id_evento))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricalcolare il credito residuo di uno studente.
     * Ricalcola il saldo del portafoglio dello studente a partire dalle ricariche e dai pasti usufruiti.
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricalcolaPortafogliStudente(id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public ricalcolaPortafogliStudente(id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public ricalcolaPortafogliStudente(id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public ricalcolaPortafogliStudente(id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling ricalcolaPortafogliStudente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetStudenteView>('put',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricalcola-portafogli`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricalcolare i portafogli di tutti gli studenti di un comune.
     * Ricalcola in blocco il saldo del portafoglio per tutti gli studenti iscritti al comune specificato. In caso di errori parziali, risponde con HTTP 206.
     * @param slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricalcolaPortafogliStudentiComune(slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public ricalcolaPortafogliStudentiComune(slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public ricalcolaPortafogliStudentiComune(slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public ricalcolaPortafogliStudentiComune(slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slug_comune === null || slug_comune === undefined) {
            throw new Error('Required parameter slug_comune was null or undefined when calling ricalcolaPortafogliStudentiComune.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/studente/ricalcola-portafogli-comune/${encodeURIComponent(String(slug_comune))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricalcolare la rendicontazione mensile per uno studente specifico.
     * Ricalcola la rendicontazione mensile del servizio mensa per lo studente e il mese indicati, con possibilità di specificare una data finale opzionale.
     * @param id_studente 
     * @param numero_mese 
     * @param dataFinale Data finale opzionale per filtrare le ricariche (formato YYYY-MM-DD)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricalcolaRendicontazioneMensile(id_studente: string, numero_mese: number, dataFinale?: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public ricalcolaRendicontazioneMensile(id_studente: string, numero_mese: number, dataFinale?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public ricalcolaRendicontazioneMensile(id_studente: string, numero_mese: number, dataFinale?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public ricalcolaRendicontazioneMensile(id_studente: string, numero_mese: number, dataFinale?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling ricalcolaRendicontazioneMensile.');
        }

        if (numero_mese === null || numero_mese === undefined) {
            throw new Error('Required parameter numero_mese was null or undefined when calling ricalcolaRendicontazioneMensile.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dataFinale !== undefined && dataFinale !== null) {
            queryParameters = queryParameters.set('dataFinale', <any>dataFinale);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/ricalcola-rendicontazione-mensile/${encodeURIComponent(String(numero_mese))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di aggiungere/modificare un identificativo menù per lo studente.
     * Imposta o aggiorna l&#x27;identificativo del menù extra associato allo studente.
     * @param body 
     * @param slugComune 
     * @param id_studente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setUpdateMenuExtra(body: IdentificativoMenuExtraForm, slugComune: string, id_studente: string, observe?: 'body', reportProgress?: boolean): Observable<GetStudenteView>;
    public setUpdateMenuExtra(body: IdentificativoMenuExtraForm, slugComune: string, id_studente: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetStudenteView>>;
    public setUpdateMenuExtra(body: IdentificativoMenuExtraForm, slugComune: string, id_studente: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetStudenteView>>;
    public setUpdateMenuExtra(body: IdentificativoMenuExtraForm, slugComune: string, id_studente: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setUpdateMenuExtra.');
        }

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling setUpdateMenuExtra.');
        }

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling setUpdateMenuExtra.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetStudenteView>('put',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/menu-extra`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Toggle disabilitazione rendicontazione
     * Disabilita o riabilita una rendicontazione. La disabilitazione è possibile solo se non è presente un dovuto attivo.
     * @param id_studente 
     * @param id_rendicontazione 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toggleDisabilitazioneRendicontazione(id_studente: string, id_rendicontazione: string, observe?: 'body', reportProgress?: boolean): Observable<Rendicontazione>;
    public toggleDisabilitazioneRendicontazione(id_studente: string, id_rendicontazione: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Rendicontazione>>;
    public toggleDisabilitazioneRendicontazione(id_studente: string, id_rendicontazione: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Rendicontazione>>;
    public toggleDisabilitazioneRendicontazione(id_studente: string, id_rendicontazione: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_studente === null || id_studente === undefined) {
            throw new Error('Required parameter id_studente was null or undefined when calling toggleDisabilitazioneRendicontazione.');
        }

        if (id_rendicontazione === null || id_rendicontazione === undefined) {
            throw new Error('Required parameter id_rendicontazione was null or undefined when calling toggleDisabilitazioneRendicontazione.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Rendicontazione>('put',`${this.basePath}/api/v1/studente/${encodeURIComponent(String(id_studente))}/rendicontazione/${encodeURIComponent(String(id_rendicontazione))}/toggle-disabilitazione`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica la presenza di difformità tra i pasti calcolati dal calendario e quelli salvati nel portafogli degli studenti.
     * Confronta i pasti calcolati dinamicamente dal calendario scolastico con i valori salvati nel portafoglio degli studenti, riportando le eventuali discrepanze.
     * @param slugComune Slug del comune (opzionale). Se non specificato, verifica tutti i comuni
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public verificaDifformitaPastiUsufruiti(slugComune?: string, observe?: 'body', reportProgress?: boolean): Observable<DifformitaPastiDTO>;
    public verificaDifformitaPastiUsufruiti(slugComune?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DifformitaPastiDTO>>;
    public verificaDifformitaPastiUsufruiti(slugComune?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DifformitaPastiDTO>>;
    public verificaDifformitaPastiUsufruiti(slugComune?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DifformitaPastiDTO>('get',`${this.basePath}/api/v1/studente/verifica-difformita-pasti`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
